import type { AgentMeta } from '@/pages/analytics/types';

/** Returns true if the agent has a real display name (not empty and not the raw ID fallback). */
export const isResolvedAgentMeta = (
  agent: AgentMeta | undefined,
  routeAgentId: string | undefined,
): boolean => {
  if (!agent?.agent_name) return false;
  if (routeAgentId && agent.agent_name === routeAgentId) return false;
  return true;
};

export const resolveDisplayAgentMeta = ({
  currentAgent,
  preservedAgent,
  routeAgentId,
}: {
  currentAgent?: AgentMeta;
  preservedAgent?: AgentMeta;
  routeAgentId?: string;
}): AgentMeta | undefined => {
  if (isResolvedAgentMeta(currentAgent, routeAgentId)) return currentAgent;

  if (
    preservedAgent?.agent_id === routeAgentId &&
    isResolvedAgentMeta(preservedAgent, routeAgentId)
  ) {
    return preservedAgent;
  }

  if (currentAgent) {
    return {
      ...currentAgent,
      agent_name: currentAgent.agent_name || currentAgent.agent_id,
    };
  }

  if (!routeAgentId) return undefined;

  return {
    agent_id: routeAgentId,
    agent_name: routeAgentId,
  };
};
